import { invoke } from "@tauri-apps/api/core";

export async function storeAuthToken(token: string): Promise<void> {
  await invoke("store_auth_token", { token });
}

export async function getAuthToken(): Promise<string | null> {
  return await invoke<string | null>("get_auth_token");
}

export async function clearAuthToken(): Promise<void> {
  await invoke("clear_auth_token");
}
